import { render, staticRenderFns } from "./AppGlobalDialogs.vue?vue&type=template&id=092073c4"
import script from "./AppGlobalDialogs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppGlobalDialogs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports